// extracted by mini-css-extract-plugin
export default {"HeroImage":"hero-module--HeroImage--H6PGu"};